import PropTypes from "prop-types";
import { InputOtp } from "primereact/inputotp";
import { getErrorMessage } from "../form/FormStandardProps";
import Label from "./Label";

const OtpInput = ({
  className,
  input,
  label,
  meta,
  required = false,
  disabled,
  count = 6,
  ...rest
}) => {
  const { touched, error } = meta || {};

  return (
    <div className={`edexlms-field otp-input ${disabled ? "disabled" : ""} `}>
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      <InputOtp
        {...input}
        id={input.name}
        required={required}
        disabled={disabled}
        invalid={touched && error}
        className={`w-full ${className}`}
        length={count}
        onChange={(e) => input.onChange(e.value)}
        {...rest}
      />
      {(touched && error && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, input, rest, label)}
        </div>
      )) ||
        null}
    </div>
  );
};

OtpInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  count: PropTypes.number,
};

export default OtpInput;
